import React from 'react'
import { useFocusByProp } from '../Core/useFocusByProp'



const NavButton = ({
    item,
    menuId,
    isExpanded=false,
    hasFocus=false,
    handleKeyDown,
    toggleExpanded,
    handleOnFocus

}) => {
    const [itemRef] = useFocusByProp(hasFocus)

    return (
        <button type="button"
            ref={itemRef}
            aria-expanded={isExpanded}
            aria-controls={menuId}
            aria-label="More About pages"
            className={isExpanded ? 'is-expanded' : ''}
            onClick={() => toggleExpanded(item.id)}
            onKeyDown={handleKeyDown}
            onFocus={handleOnFocus}
        />
    )
}

export default NavButton